export const changeType = {
  data () {
    return {
      type: 1,
      typeOptions: [
        {
          value: 1,
          label: this.$t('addConfigModule.preciseCorrelation')
        },
        {
          value: 2,
          label: this.$t('addConfigModule.fuzzySearch')
        }
      ]
    };
  },
  methods: {
    handleTypeChange () {
      let params = this.$route.params;
      this.$router.push({
        name: 'AdditionProduct/add',
        params: { ...params, routerPath: 'PreciseAssociation' }
      });
      // 判断type ，如果=1，跳转到精准关联页面，否则跳转到模糊查询页面
      // if (this.type === 1) {
      //   this.$router.push({
      //     name: "PreciseAssociation/add",
      //     params: { ...params, routerPath: "AdditionProduct" }
      //   });
      // }
      // if (this.type === 2) {
      //   this.$router.push({
      //     name: "AdditionProduct/add",
      //     params: { ...params, routerPath: "PreciseAssociation" }
      //   });
      // }
    }
  }
};
